// Derives the plural-aware unit label for the "Repeat every {N} {unit}"
// sentence row in the recurrence panel. Singular when N=1, plural otherwise.

import type { RecurrenceFrequency } from "../../../../types";

const SINGULAR: Record<RecurrenceFrequency, string> = {
  daily: "Day",
  weekly: "Week",
  monthly: "Month",
  quarterly: "Quarter",
  annually: "Year",
};

export function frequencyUnitLabel(
  frequency: RecurrenceFrequency,
  interval: number,
): string {
  const singular = SINGULAR[frequency];
  if (!singular) {
    return interval === 1 ? String(frequency) : `${String(frequency)}s`;
  }
  return interval === 1 ? singular : `${singular}s`;
}
